// ----------------------------------------------------------------------------
// Component: Long Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_long-panel.scss';
